import { useEffect, useState } from 'react';

export function useScrollSpy(ids: string[]) {
    const [activeId, setActiveId] = useState<string>();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries.find(({ isIntersecting }) => isIntersecting);

                if (entry) {
                    setActiveId(entry.target.id);
                }
            },
            { rootMargin: '0% 0% -25% 0%' },
        );

        ids.map((id) => document.getElementById(id))
            .filter((element): element is HTMLElement => element !== null)
            .forEach((element) => observer.observe(element));

        return () => observer.disconnect();
    }, [ids]);

    return activeId;
}
